<template>
    <DropdownMenu
        v-if="canNotifications"
        :position-x-offset="-8"
        :position-y-offset="8"
        :width="400"
        :has-no-padding="true"
        :has-shadow="true"
        dropdown-class="top-bar-user-menu"
    >
        <template #activator>
            <span class="notification-button-activator">
                <ActionIconButton
                    is-rounded
                    icon="fa-solid fa-bell"
                    icon-class="icon-color"
                    :title="$t('Notifications')"
                    :aria-label="$t('Notifications')"
                    aria-haspopup="menu"
                    size="xl"
                />
                <span v-if="visibleNotificationsCount > 0" class="notifications-mark" />
            </span>
        </template>
        <template #items="{ onClose }">
            <NotificationsDropdown
                :notifications-count="visibleNotificationsCount"
                @close="onClose"
                @notifications-count-change="onNotificationsCountChange"
            />
        </template>
    </DropdownMenu>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ActionIconButton from "@/components/buttons/ActionIconButton.vue";
import DropdownMenu from "@/components/dropdowns/dropdown-menu/DropdownMenu.vue";
import NotificationsDropdown from "@/components/dropdowns/dropdown-menu/NotificationsDropdown.vue";

export default defineComponent({
    components: {
        ActionIconButton,
        DropdownMenu,
        NotificationsDropdown,
    },
    name: "NotificationsButton",
    emits: ["notifications-count-change"],
    props: {
        visibleNotificationsCount: {
            type: Number,
            required: true,
        },
        canNotifications: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        onNotificationsCountChange: function (count: number, options?: { optimistic?: boolean }) {
            this.$emit("notifications-count-change", count, options);
        },
    },
});
</script>

<style scoped>
.notification-button-activator {
    position: relative;
    display: inline-flex;
}

.notification-button-activator .notifications-mark {
    pointer-events: none;
}
</style>
